import React from 'react';
import styled from 'styled-components';
import { ImageUrl } from '../../../utils/constants';
import PropTypes from 'prop-types';

const BackDrop = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1000;
  ${'' /* background-color: rgba(153, 153, 153, 0.25); */}
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction:column;

  .loader-text{
    color: #184A61;
    font-family: Lato;
    font-size: 24px;
    font-style: normal;
    font-weight: 700;
    line-height: 36px; 
    margin-top:32px;
    display:flex;
    width:100%;
    justify-content:center;
    align-items:center;
    text-align:center;
   }
`;

const GifLoader = styled.img`
  width: 100%; /* adjust as needed */
  height: 100%;
`;

const CongratulationsLoader = ({gifUrl}) => (
  <BackDrop>
    <GifLoader src={gifUrl ? gifUrl : ImageUrl + "/loader/congratulation.gif"} alt="Loading..." />
  </BackDrop>
);

CongratulationsLoader.propTypes = {
  text: PropTypes.string,
  gifUrl:PropTypes.string
}

export default CongratulationsLoader;
